import React, { Component } from 'react';

export const generateLabel = (text = "") => {
    return (
        <div>
            <label htmlFor="" style={{ marginBottom: 12 }}>
                {text}
            </label>
        </div>
    );
}

export const getFrontPageUrl = () => {
    const host = window.location.hostname;

    const baseUrlProduccion     = `https://exportemos.pe`;
    const baseUrlQaPreProd      = `https://qa2.exportemos.pe`;
    const baseUrlQa             = `https://qa.exportemos.pe`; 
    const baseUrlProveedor      = `https://devexportemos.promperu.gob.pe`;
    const baseUrlDev            = `https://localhost:5004`;

    let apiUrl = baseUrlProveedor;

    if(host === 'localhost' || host === '127.0.0.1'){
        apiUrl = baseUrlDev;
        apiUrl = baseUrlProveedor //jorge@hardcode
    }else if(host === 'cms.exportemos.pe'){
        apiUrl = baseUrlProduccion;
    }else if(host === 'cms-qa.exportemos.pe'){
        apiUrl = baseUrlQa;
    }else if(host === 'cms-qa2.exportemos.pe'){
        apiUrl = baseUrlQaPreProd;
    }else if(host === 'devexportemos-cms.promperu.gob.pe' ){
        apiUrl = baseUrlProveedor;
    }
    console.log("Url apis", apiUrl, " - host: ", host);

    return apiUrl;
}

export const bearerTknCache = () => 'BpZ88PGVn2i2ROiJw4K1gO9QJmRt0I6ibAEXazGlua6FTD35LpUCMvDNvjAF02Eo';
export const cacheConfig = {
    headers: { Authorization: `Bearer ${bearerTknCache()}` }
};